/** The two ways to play. Creative is the classic sandbox; survival adds stakes. */
export type GameMode = "creative" | "survival";

export const MODE_LABELS: Record<GameMode, string> = {
  creative: "Creative",
  survival: "Survival",
};

export function isSurvival(mode: GameMode): boolean {
  return mode === "survival";
}

/** Parse a `?mode=` URL parameter, defaulting to creative. */
export function parseMode(value: string | null): GameMode {
  return value === "survival" ? "survival" : "creative";
}
